/* eslint-disable */
import { FuseNavigationItem } from '@fuse/components/navigation';

export const defaultNavigation: FuseNavigationItem[] = [
    {
        id: 'dashboards',
        // title   : 'Dashboards',
        // subtitle: 'Unique dashboard designs',
        type: 'group',
        icon: 'heroicons_outline:home',
        children: [
            {
                id: 'admindashboards.Dashboard',
                title: 'Admin Dashboard',
                type: 'basic',
                icon: 'heroicons_outline:clipboard-document-check',
                link: '/admin-dashboard',
                role: ['PM', 'Super Admin',],
            },
            {
                id: 'finance-manager.dashboard',
                title: 'Dashboard',
                type: 'basic',
                icon: 'heroicons_outline:clipboard-document-check',
                link: '/finance-manager',
                role: ['Financial Manager'],
            },
            {
                id: 'attendance.details',
                title: 'Attendance Details',
                type: 'basic',
                icon: 'heroicons_outline:clipboard-document-check',
                link: '/attendance/attendance/attendance-dashboard',
                role: ['PM', 'Super Admin', 'HR Manager', 'HR Recruitment'],
            },
            {
                id: 'account-manager.dashboard',
                title: 'Dashboard',
                type: 'basic',
                icon: 'heroicons_outline:clipboard-document-check',
                link: '/account-manager/dashboard',
                role: ['Accounting Manager'],
            },
            {
                id: 'it.Dashboard',
                title: 'IT Dashboard',
                type: 'basic',
                icon: 'heroicons_outline:clipboard-document-check',
                link: '/it-team/it-dashboard',
                role: ['IT Team'],
            },
            {
                id: 'attendance.punch-in',
                title: 'Attendance',
                type: 'basic',
                icon: 'heroicons_outline:calendar-days',
                link: '/attendance/attendance-punch-in',
                role: ['Super Admin', 'Quality Assurance', 'Frontend Developer', 'Backend Developer', 'Devops', 'Technical Lead (Frontend)', 'Employee', 'Technical Lead (Backend)', 'Fullstack Developer', 'Quality Assurance Lead', 'Project Manager', 'HR Manager', 'HR Recruitment', 'ProjectManager'],
            },
            // {
            //     id: 'attendance.team-attendance',
            //     title: 'Team Attendance',
            //     type: 'basic',
            //     icon: 'heroicons_outline:user-group',
            //     link: '/team-attendance',
            //     role: ['PM', 'ProjectManager', 'Project Manager', 'Technical Lead (Frontend)', 'Technical Lead (Backend)', 'Quality Assurance Lead', 'HR Manager', 'Super Admin'],
            // },


            {
                id: 'employee.employeeProfile',
                title: 'Profile',
                type: 'basic',
                icon: 'heroicons_outline:user',
                link: '/employee/employeeProfile/employeeProfile',
                role: ['Super Admin', 'Backend Developer', 'Devops', 'Employee', 'Frontend Developer', 'Technical Lead (Backend)', 'Fullstack Developer', 'Quality Assurance', 'Technical Lead (Frontend)', 'Quality Assurance Lead', 'Project Manager', "HR Recruitment", "HR Manager", "ProjectManager"],
            },
            {
                id: 'employee.employees',
                title: 'Employees',
                type: 'basic',
                icon: 'heroicons_outline:user-group',
                link: '/employee/employeeList/employeeList',
                role: ['PM', 'Super Admin',],
            },
            {
                id: 'employee.list',
                title: 'Employee List',
                type: 'basic',
                icon: 'heroicons_outline:user-group',
                link: '/employee/employeeList/employeeList',
                role: ["HR Recruitment", "HR Manager",],
            },
            {
                id: 'employee.candidate-onboarding',
                title: 'Candidate Onboarding',
                type: 'basic',
                icon: 'heroicons_outline:user-group',
                link: '/employee/employee-management/list',
                role: ['PM', 'Super Admin', 'IT Team'],
            },
            {
                id: 'employee.teams',
                title: 'Teams',
                type: 'basic',
                icon: 'heroicons_outline:user-group',
                link: '/coherent-teams',
                role: ['Employee', 'HR Recruitment', 'Technical Lead (Backend)', 'Technical Lead (Frontend)', 'Project Manager', 'HR Manager', 'Quality Assurance Lead', 'Fullstack Developer', 'Backend Developer', 'Devops','Frontend Developer', 'Quality Assurance', 'ProjectManager', 'PM', 'Super Admin']
            },
            {
                id: 'employee.my-team',
                title: 'My Team',
                type: 'basic',
                icon: 'heroicons_outline:user-group',
                link: '/my-teams',
                role: ['Technical Lead (Backend)', 'ProjectManager', 'Technical Lead (Frontend)', "Super Admin", 'Project Manager', 'Quality Assurance Lead', "HR Recruitment", "HR Manager"]
            },
            {
                id: 'employee.clients',
                title: 'Clients',
                type: 'basic',
                icon: 'heroicons_outline:user-group',
                link: '/client',
                role: ["Super Admin", 'PM',]
            },
            {
                id: 'employee.projects',
                title: 'Projects',
                type: 'basic',
                icon: 'heroicons_outline:user-group',
                link: '/coherent-projects/coherent-emp-Projects-list',
                role: ['Employee', 'Technical Lead (Backend)', 'Technical Lead (Frontend)', 'Quality Assurance Lead', 'Frontend Developer', 'Backend Developer', 'Devops'],
            },
            {
                id: 'employee.my-projects',
                title: 'My Projects',
                type: 'basic',
                icon: 'heroicons_outline:clipboard-document-list',
                link: '/my-projects',
                role: ['ProjectManager', 'Project Manager'],
            },
            {
                id: 'employee.trainees',
                title: 'Trainee Programmer Intern',
                type: 'basic',
                icon: 'heroicons_outline:user-group',
                link: '/trainees',
                role: ["Super Admin", 'PM', "HR Recruitment", "HR Manager"],
            },
            {
                id: 'employee.key-skills',
                title: 'Key Skills',
                type: 'basic',
                icon: 'heroicons_outline:academic-cap',
                link: '/key-skills',
                role: ["Super Admin", 'PM', "HR Recruitment", "HR Manager"],
            },
            {
                id: 'employee.interview',
                title: 'Interview',
                type: 'basic',
                icon: 'heroicons_outline:user-group',
                link: '/interview',
                role: ["HR Recruitment", "HR Manager"]
            },
            {
                id: 'branch.branch-management',
                title: 'Branch Management',
                type: 'basic',
                icon: 'heroicons_outline:calendar-days',
                link: '/branch-management',
                role: ['PM', 'Super Admin'],
            },
            {
                id: 'apps.ecommerce.inventory',
                title: 'Inventory',
                type: 'collapsable',
                icon: 'heroicons_outline:shopping-cart',
                role: ['PM', 'Super Admin', 'IT Team'],
                children: [
                    {
                        id: 'apps.ecommerce.inventory.list',
                        title: 'Inventory List',
                        type: 'basic',
                        link: '/inventory/inventory-list',
                        role: ['PM', 'Super Admin', 'IT Team'],

                    },
                    {
                        id: 'apps.ecommerce.inventory.details',
                        title: 'Inventory Details',
                        type: 'basic',
                        link: '/inventory/inventory-details',
                        role: ['PM', 'Super Admin', 'IT Team'],

                    }
                ]
            },
            {
                id: 'license.softwareLicense',
                title: 'Software License',
                type: 'basic',
                icon: 'heroicons_outline:shopping-cart',
                link: '/license-management',
                role: ['IT Team'],
            },
            {
                id: 'reimbursement.employee',
                title: 'Reimbursement',
                type: 'basic',
                icon: 'heroicons_outline:currency-dollar',
                link: '/reimbursement',
                // link: '/pages/maintenance',
                role: ["HR Recruitment", 'Technical Lead (Backend)', 'ProjectManager', 'Technical Lead (Frontend)', 'PM', 'Employee', 'Project Manager', "HR Manager", 'Fullstack Developer', 'Backend Developer', 'Devops', "Frontend Developer", 'Quality Assurance Lead', 'Quality Assurance']
            },
            {
                id: 'reimbursement.approve',
                title: 'Reimbursement',
                type: 'basic',
                icon: 'heroicons_outline:currency-dollar',
                link: '/reimbursement/reimbursement-approve-list',
                // link: '/pages/maintenance',
                role: ['Super Admin']
            },

            {
                id: 'account-manager.coherent-vendor',
                title: 'Coherent Vendors',
                type: 'basic',
                icon: 'heroicons_outline:user-group',
                link: '/account-manager/coherent-vendor',
                role: ['Accounting Manager'],
            },
            {
                id: 'account-manager.purchase-invoice',
                title: 'Purchase Invoices   ',
                type: 'basic',
                icon: 'heroicons_outline:currency-dollar',
                link: '/account-manager/purchese-invoice',
                role: ['Accounting Manager'],
            },

            {
                id: 'account-manager.coherent-expense',
                title: 'Coherent Expences',
                type: 'basic',
                icon: 'heroicons_outline:currency-dollar',
                link: '/account-manager/coherent-expence',
                role: ['Accounting Manager'],
            },
            {
                id: 'account-manager.recurring-expense',
                title: 'Recurring Expences',
                type: 'basic',
                icon: 'heroicons_outline:currency-dollar',
                link: '/account-manager/recurring-expence',
                role: ['Accounting Manager'],
            },
            {
                id: 'reimbursement.account-list',
                title: 'Reimbursement',
                type: 'basic',
                icon: 'heroicons_outline:currency-dollar',
                link: '/reimbursement/reimbursement-account-list',
                role: ['Accounting Manager'],
            },
            {
                id: 'account-manager.payment-details',
                title: 'Payment Details',
                type: 'basic',
                icon: 'heroicons_outline:currency-dollar',
                link: '/account-manager/payment-details',
                role: ['Accounting Manager'],
            },
            {
                id: 'finance-manager.approvals',
                title: 'Approvals',
                type: 'basic',
                icon: 'heroicons_outline:currency-dollar',
                link: '/approvals/approvals',
                role: ['Financial Manager'],
            },
            {
                id: 'finance-manager.approvals-total-amount-view',
                type: 'basic',
                title: 'Payment Details',
                icon: 'heroicons_outline:currency-dollar',
                link: '/payment',
                role: ['Financial Manager'],
            },
            {
                id: 'master',
                title: 'Master Data',
                type: 'collapsable',
                icon: 'heroicons_outline:computer-desktop',
                role: ['PM', 'Super Admin', 'HR Manager' ],
                children: [

                    {
                        id: 'master.clients',
                        title: 'Client Details',
                        type: 'basic',
                        link: '/masterdata/clients',
                        role: ['PM', 'Super Admin', 'HR Manager' ],
                    },
                    {
                        id: 'master.Project',
                        title: 'Project',
                        type: 'basic',
                        link: '/masterdata/project',
                        role: ['PM', 'Super Admin', 'HR Manager' ],
                    },
                    {
                        id: 'master.Team-Mapping',
                        title: 'Team Mapping',
                        type: 'basic',
                        link: '/masterdata/team-mapping',
                        role: ['PM', 'Super Admin', 'HR Manager' ],
                    },
                    {
                        id: 'UserAccess.Dashboard',
                        title: 'User Access',
                        type: 'basic',
                        link: '/user-access',
                        role: ['PM', 'Super Admin', 'HR Manager' ],
                    },
                    {
                        id: 'master.Holiday',
                        title: 'Holiday',
                        type: 'basic',
                        link: '/masterdata/holiday',
                        role: ['PM', 'Super Admin', 'HR Manager' ]
                    }


                ],
            },
        ],
    },
];
export const compactNavigation: FuseNavigationItem[] = [
    {
        id: 'dashboards',
        title: 'Dashboards',
        tooltip: 'Dashboards',
        type: 'aside',
        icon: 'heroicons_outline:home',
        children: [], // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
    },
    {
        id: 'apps',
        title: 'Apps',
        tooltip: 'Apps',
        type: 'aside',
        icon: 'heroicons_outline:qrcode',
        children: [], // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
    },
    {
        id: 'pages',
        title: 'Pages',
        tooltip: 'Pages',
        type: 'aside',
        icon: 'heroicons_outline:document-duplicate',
        children: [], // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
    },
    {
        id: 'user-interface',
        title: 'UI',
        tooltip: 'UI',
        type: 'aside',
        icon: 'heroicons_outline:rectangle-stack',
        children: [], // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
    },
    {
        id: 'navigation-features',
        title: 'Navigation',
        tooltip: 'Navigation',
        type: 'aside',
        icon: 'heroicons_outline:bars-3',
        children: [], // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
    },
];
export const futuristicNavigation: FuseNavigationItem[] = [
    {
        id: 'dashboards',
        title: 'DASHBOARDS',
        type: 'group',
        children: [], // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
    },
    {
        id: 'apps',
        title: 'APPS',
        type: 'group',
        children: [], // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
    },
    {
        id: 'others',
        title: 'OTHERS',
        type: 'group',
    },
    {
        id: 'pages',
        title: 'Pages',
        type: 'aside',
        icon: 'heroicons_outline:document-duplicate',
        children: [], // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
    },
    {
        id: 'user-interface',
        title: 'User Interface',
        type: 'aside',
        icon: 'heroicons_outline:rectangle-stack',
        children: [], // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
    },
    {
        id: 'navigation-features',
        title: 'Navigation Features',
        type: 'aside',
        icon: 'heroicons_outline:bars-3',
        children: [], // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
    },
];
export const horizontalNavigation: FuseNavigationItem[] = [
    {
        id: 'dashboards',
        title: 'Dashboards',
        type: 'group',
        icon: 'heroicons_outline:home',
        children: [], // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
    },
    {
        id: 'apps',
        title: 'Apps',
        type: 'group',
        icon: 'heroicons_outline:qrcode',
        children: [], // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
    },
    {
        id: 'pages',
        title: 'Pages',
        type: 'group',
        icon: 'heroicons_outline:document-duplicate',
        children: [], // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
    },
    {
        id: 'user-interface',
        title: 'UI',
        type: 'group',
        icon: 'heroicons_outline:rectangle-stack',
        children: [], // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
    },
    {
        id: 'navigation-features',
        title: 'Misc',
        type: 'group',
        icon: 'heroicons_outline:bars-3',
        children: [], // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
    },
];
